module.exports = __webpack_public_path__ + "img/02082008000412.1edde72d.png";